import { Track } from 'livekit-client';

import { useLiveStreamContext } from 'client/components/LiveStreamConnector/context';
import { eventBus } from 'client/utils/event-bus';

type ToggleMicResult = { muteMic: () => void; unMuteMic: () => void };

export function useToggleMicrophone(): ToggleMicResult {
  const { state } = useLiveStreamContext();

  const muteMic = () => {
    const audioTrack = state.space?.localParticipant?.getTrack(Track.Source.Microphone);

    if (!audioTrack) return;

    audioTrack.mute();
    console.info('useToggleMicrophone muteMic');

    eventBus.publish('TOGGLE_LOCAL_MIC', { isMuted: true });
  };

  const unMuteMic = () => {
    const audioTrack = state.space?.localParticipant?.getTrack(Track.Source.Microphone);

    if (!audioTrack) return;

    audioTrack.unmute();
    console.info('useToggleMicrophone unMuteMic');

    eventBus.publish('TOGGLE_LOCAL_MIC', { isMuted: false });
  };

  return { muteMic, unMuteMic };
}
